import { useFormContext } from 'react-hook-form';
import { ConfirmRejectForm } from '../types';

export const useConfirmRejectForm = () => {
  const methods = useFormContext<ConfirmRejectForm>();
  return { methods };
};
